import ApiModel from './globals/ApiModel';

export default class TestSourceConnectionModel extends ApiModel {
  static get path() {
    return '/backend/sources/{id}/test_connection';
  }
}
